module.exports = __webpack_public_path__ + "32c717dc2af518b171fb2c415552106d.jpg";